import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=90749250"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"
import style0 from "./Slider.vue?vue&type=style&index=0&id=90749250&prod&lang=scss"
import style1 from "./Slider.vue?vue&type=style&index=1&id=90749250&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports